import { observer } from 'mobx-react';
import React from 'react';

import { Paginated } from '../../../../adl-gen/common';
import { DbKey } from '../../../../adl-gen/common/db';
import { Question } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { Loader, MaybeLoading } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { PageLayoutFn } from '../../../../ui/common/page-layout/page-layout';
import { QuestionCompetencySkillsMap } from '../../../stores';
import { ListView } from '../../common/list/list-view';
import { QuestionListEntry, QuestionListView } from '../../components/lists/question-list/question-list-view';

interface QuestionScreenProps {
  pageLayout: PageLayoutFn;
  navigateTo(route: Route): void;

  questions: MaybeLoading<Paginated<QuestionListEntry>>;
  competencySkillsMap: MaybeLoading<QuestionCompetencySkillsMap>;
}

@observer
export class QuestionScreen extends React.Component<QuestionScreenProps> {
  onSelectQuestion = async (id: DbKey<Question>) => {
    this.props.navigateTo({
      route: 'admin',
      page: 'question',
      id
    });
  };

  onCreateQuestion = () => {
    this.props.navigateTo({
      route: 'admin',
      page: 'question',
      view: 'new'
    });
  };

  renderQuestionList = observer((questions: Paginated<QuestionListEntry>) => {
    const { competencySkillsMap } = this.props;
    const map = competencySkillsMap.kind === 'value' ? competencySkillsMap.value : undefined;
    return (
      <ListView
        list={questions}
        fields={QuestionListView}
        refData={map}
        onSelect={this.onSelectQuestion}
        onCreate={this.onCreateQuestion}
      />
    );
  });

  QuestionsLoader = () => <Loader state={this.props.questions} LoadedComponent={this.renderQuestionList} />;

  render() {
    /// Title is required to ensure subnav gets rendered
    return (
      <this.props.pageLayout title={'Questions and Answers'}>
        <this.QuestionsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/question-screen/question-screen.tsx